<template>
  <div class="layout">
    <div class="container sign-up-page login-page no-image-auth-style">
      <div class="row">
        <div class="col-lg-12 text-center">
          <div class="col-md-12 col-lg-4 col-sm-12 col-sm-0 offset-33">
            <!-- <b-link to="/">
            <img
              class="logo-img"
              src="/img/brand/logo.png"
              alt="logo"
            />
            </b-link> -->
            <div class="mt-5">
              <slide-x-right-transition
                :duration="pageTransitionDuration"
                mode="out-in"
              >
                <router-view></router-view>
              </slide-x-right-transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseNav } from "@/components";
import {
  ZoomCenterTransition,
  FadeTransition,
  SlideXRightTransition,
} from "vue2-transitions";
import "@/assets/css/layout/auth-style.scss";

export default {
  components: {
    BaseNav,
    ZoomCenterTransition,
    FadeTransition,
    SlideXRightTransition,
  },

  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },

  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page",
      styleClass: "",
      containerClass: "container sign-up-page login-page no-image-auth-style",
    };
  },

  computed: {
    // title() {
    //   return `${this.$route.name} Page`;
    // },
  },

  mounted() {
    if (this.$route.name == "login" || this.$route.name == "register") {
      this.styleClass = "col-md-12 col-lg-12 col-sm-12 col-sm-0";
      this.containerClass = "container sign-up-page login-page";
    } else {
      this.styleClass = "col-md-12 col-lg-4 col-sm-12 col-sm-0 offset-33";
      this.containerClass =
        "container sign-up-page login-page no-image-auth-style";
    }
  },

  updated() {
    if (this.$route.name == "login" || this.$route.name == "register") {
      this.styleClass = "col-md-12 col-lg-12 col-sm-12 col-sm-0";
      this.containerClass = "container sign-up-page login-page";
    } else {
      this.styleClass = "col-md-12 col-lg-4 col-sm-12 col-sm-0 offset-33";
      this.containerClass =
        "container sign-up-page login-page no-image-auth-style";
    }
  },

  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },

    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },

    setBackgroundColor() {
      document.body.classList.add("text-center");
    },

    removeBackgroundColor() {
      document.body.classList.remove("text-center");
    },

    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    },
  },

  beforeDestroy() {
    this.removeBackgroundColor();
  },

  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler: function () {
        this.updateBackground();
      },
    },
  },
};
</script>

<style lang="scss">
input {
  color: rgb(0, 0, 0) !important;
}

.no-image-auth-style {
  .form-signin {
    margin-top: 24px;
    // margin-bottom: 24px;
  }

  .card .row {
    padding-right: 0%;
    padding-left: 0%;
    padding-top: 0px;
  }
}

$scaleSize: 0.8;

@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}

.offset-33 {
  @media (min-width: 992px) {
    margin-right: 33.33333%;
  }
}
</style>
